<template>
  <div class="bg-grey-lighter rounded-lg">
    <div class="flex flex-row items-center justify-between p-3">
      <span class="font-semibold text-sm">{{ title }}</span>
      <div class="flex flex-col text-right">
        <div class="flex flex-row">
          <span class="font-bold text-sm mb-1" :class="`text-${text_color}`">
            ₱{{ formatMoney(balance) }}
          </span>
          <img
              :src="require(`@/assets/icons/${
                show_account
                  ? 'papsi_password_visible.svg'
                  : 'papsi_password_invisible.svg'
              }`)"
              class="w-4 h-4 ml-1 cursor-pointer"
            />
        </div>
        <span class="text-xxs text-muted">as of {{ date }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BalanceDisplayControl",
  props: {
    title: {
      type: String,
      default: "Regular Savings Deposit",
    },
    balance: {
      type: Number,
      default: 1000000,
    },
    text_color: {
      type: String,
      default: "primary",
    },
    date: {
      type: String,
      default: () => {
        const today = new Date();

        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        const year = today.getFullYear();

        return `${month}/${day}/${year}`;
      },
    },
  },
  methods: {
    formatMoney(value) {
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
<style></style>
